import NiceModal from '@ebay/nice-modal-react';
import { Box, Table, Text } from '@mantine/core';

import { useGetRoles } from '../api/getRoles';

import { RoleModal } from './RoleModal';
import { RoleRow } from './RoleRow';

import { AddButton, ListLoader } from '@/components';

export const RolesTable = () => {
  const { data, isLoading, isError } = useGetRoles();
  const { roles = [] } = data || {};

  if (isLoading) {
    return <ListLoader />;
  }

  if (isError) {
    return <Text c="red">Failed to load roles</Text>;
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <Table stickyHeader striped highlightOnHover withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Name</Table.Th>
              <Table.Th>Description</Table.Th>
              <Table.Th>Permissions</Table.Th>
              <Table.Th>Page access</Table.Th>
              <Table.Th>Managers</Table.Th>
              <Table.Th />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {roles.map((role) => (
              <RoleRow key={role._id} role={role} />
            ))}
          </Table.Tbody>
        </Table>
      </Box>
      <AddButton size={60} onClick={() => NiceModal.show(RoleModal, {})} ariaLabel="Add role" />
    </Box>
  );
};
